import Logger from "js-logger";
import { LOG_LEVEL, LOG_LOGGER_NAME } from "./const";
var loggerName = LOG_LOGGER_NAME;
// Display inside window
// eslint-disable-next-line
Logger.useDefaults();
export var logger = Logger.get(loggerName);
var envLevel = LOG_LEVEL;
var validLevels = ["TRACE", "DEBUG", "INFO", "TIME", "WARN", "ERROR", "OFF"];
var logLevels = [Logger.TRACE, Logger.DEBUG, Logger.INFO, Logger.TIME, Logger.WARN, Logger.ERROR, Logger.OFF];
var index = validLevels.indexOf(envLevel);
var levelIndex = index < 0 ? 5 : index;
logger.setLevel(logLevels[levelIndex]);
logger.debug("Niveau de log actuel: ".concat(validLevels[levelIndex]));
/**
 * Logger service
 */
export function useLogger() {
    return { logger: logger };
}
